import React from 'react';
import {
	Button
} from 'semantic-ui-react';

import './index.css';

export class ChatedToggle extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			basic: true
		};
	}

	onClickLeft = (e) => {
		if (this.state.basic === true) {
			this.setState({
				basic: false
			}, () => { this.props.isLeftActive(true); });
		}
	}

	onClickRight = (e) => {
		if ((!this.state.basic) === true) {
			this.setState({
				basic: true
			}, () => { this.props.isLeftActive(false); });
		}
	}

	render() {
		return(
			<Button.Group className='right' style={ this.props.style }>
				<Button basic={this.state.basic} onClick={this.onClickLeft} color='blue'>{ this.props.leftText }</Button>
				<Button basic={!this.state.basic} onClick={this.onClickRight} color='blue'>{ this.props.rightText }</Button>
			</Button.Group>
		);
	}
}

export default ChatedToggle;



// WEBPACK FOOTER //
// ./src/components/toggle/index.js